<div
  #mainBox
  [class.top-box]="isTopBox"
  [class.bottom-box]="isBottomBox"
  class="dtt-box pointer"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
  [class.disabled]="!enabled"
>
  <div
    class="flag flex-column no-select"
    (click)="clickedBox()"
    [class.dtt-box-container]="isTopBox && isBottomBox"
    [class.flag-all-trials]="
      selectedOptions.length >= requiredTrials && selectedOptions.length > 0
    "
    (mousedown)="startLongPress()"
    (mouseup)="endLongPress($event)"
    (mouseleave)="endLongPress($event)"
    (touchstart)="startLongPress()"
    (touchend)="endLongPress($event)"
    (touchcancel)="endLongPress($event)"
  >
    {{ text }}

    <span class="sd-text">{{ target?.DiscriminativeStimulus }}</span>
    <button
      class="button-program"
      *ngIf="isBottomBox"
      [style.background-color]="getStatusColor()"
      [style.border-color]="getStatusColor()"
    >
      {{ getStatusText() }}
    </button>
    <!-- <button class="badge-bottom-left">?</button> -->
    <span
      *ngIf="selectedOption"
      class="badge-count"
      (click)="openExtra2($event)"
      [style.color]="selectedOption.Color"
      [style.border-color]="selectedOption.Color"
      >{{ totalSuccess }}/{{ selectedOptions.length }}</span
    >
    <span
      *ngIf="selectedOption"
      class="badge badge-left dtt-option-icon"
      (click)="openExtra2($event)"
      [style.color]="selectedOption.Color"
      [style.border-color]="selectedOption.Color"
    >
      {{ getIcon(selectedOption) }}
    </span>

    <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
    <button
      class="badge-bottom-right"
      (click)="openDetails($event)"
      title="Remaining desired Trials"
      *ngIf="remainingTrials > 0"
    >
      {{ remainingTrials }}
    </button>
  </div>
</div>

@if (detailsOpened) {
<app-target-details
  [target]="target"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}
<div class="extra-container" #extraBox [class.hide]="!extraOpened">
  <div class="extra-close" (click)="closeExtra()">X</div>
  <div class="extra-container-textbox">
    <div
      *ngFor="let option of options"
      class="pointer data-entry-box"
      [class.data-recorded-success]="lastRecordedOptionId === option.ID"
      [class.data-buffer-active]="
        addingTargetData && cooldownOptionId === option.ID
      "
      (click)="selectOption(option)"
    >
      <div
        class="dtt-option"
        [style.background-color]="option.Color"
        [class.current]="
          promptSchedule && option.ID == this.currentPromptCodeID
        "
      >
        <span class="dtt-option-icon" [style.color]="option.Color">{{
          getIcon(option)
        }}</span>
        <span class="dtt-option-name">{{ option.Text }}</span>
      </div>
      <div
        class="data-entry-cooldown-bar"
        [class.data-entry-cooldown-active]="
          addingTargetData && cooldownOptionId === option.ID
        "
        aria-hidden="true"
      >
        <div class="data-entry-cooldown-bar-fill"></div>
      </div>
    </div>
  </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
  <div class="extra-close" (click)="closeExtra2()">X</div>
  <div class="extra-container-textbox">
    <div *ngFor="let option of selectedOptions; let i = index">
      <span
        class="float-right extra-list-trash-icon pointer"
        (click)="deleteData(option.RecordedDate)"
        ><i class="pi pi-trash"></i
      ></span>
      {{ "@ " + option.FormattedDate }}
      <div class="dtt-option" [style.background-color]="option.Color">
        <span class="dtt-option-icon" [style.color]="option.Color">{{
          getIcon(option)
        }}</span>
        <span class="dtt-option-name">{{ option.Text }}</span>
      </div>
    </div>
  </div>
</div>
